export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautifully%20organized%20product%20display%20with%20folded%20cashmere%20sweaters%20designer%20perfume%20bottles%20leather%20belts%20and%20fashion%20accessories%20arranged%20in%20neat%20rows%20on%20light%20oak%20surface%2C%20soft%20warm%20sunlight%20streaming%20through%20large%20window%2C%20neutral%20cream%20and%20beige%20tones%2C%20minimalist%20retail%20photography%2C%20elegant%20peaceful%20aesthetic&width=1800&height=900&seq=cta-full-v9&orientation=landscape"
          alt="Explore Superbuy Spreadsheet resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4 animate-fade-in-up">
          Ready to Explore Superbuy Spreadsheet?
        </h2>
        <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-8 max-w-lg mx-auto animate-fade-in-up animation-delay-200">
          Discover thousands of curated products, in-depth guides, and organized shopping resources. Start your smarter shopping journey today.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer animate-fade-in-up animation-delay-400 group"
        >
          <span className="w-7 h-7 flex items-center justify-center bg-primary-500 rounded-full">
            <i className="ri-shopping-bag-3-line text-background-50 text-xs"></i>
          </span>
          Visit Kaspreadsheet
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
        </a>
      </div>
    </section>
  );
}